
export const MODAL_TYPES = {
  calendar: 'calendar',
  conflict: 'conflict',
  timeoff: 'timeoff',
};